'use strict';

exports.atob = self.atob.bind(self);
exports.btoa = self.btoa.bind(self);